import React from "react";
import styled, { css } from "styled-components";

import DropZoneMultiFile from "src/core/shared/components/dropzones/DropZoneMultiFile";
import { FileData } from "src/core/shared/components/files/ListFiles";

export interface AddAttachmentsProps {
  setAttachments: (fileData: FileData[]) => void;
  title?: string;
  description?: string;
}

/**
 * Renders a dropzone for attaching files to a form
 * @returns
 */
export const AddAttachments: React.FunctionComponent<AddAttachmentsProps> = ({
  title, description, setAttachments
}) => {
  const updateAttachements = React.useCallback((files: FileData[]) => {
    setAttachments(files);
    // issue with formik seFieldValue causes infinite re-render on value
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ ]);

  return (
    <AttachmentsStyledWrapper>
      <DropZoneMultiFile
        updateFilesToSave={updateAttachements}
        dropzoneTitle={title || "Attachments"}
        dropzoneMessage={description || "Drag and drop files into this box you would like to attach."}
      />
    </AttachmentsStyledWrapper>
  );
};

const AttachmentsStyledWrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    max-width: 400px;
  `}
`;
